"use client";

import { useCallback, useState } from "react";
import type { Version } from "@/generated/fastapi";

export default function useManageVersionState() {
  const [selectedVersions, setSelectedVersions] = useState<Version[]>([]);
  const [selectorEpoch, setSelectorEpoch] = useState(0);

  const resetSelection = useCallback(() => {
    setSelectedVersions([]);
    setSelectorEpoch((current) => current + 1);
  }, []);

  const canDelete = selectedVersions.length > 0;
  const canUseSingleVersion = selectedVersions.length === 1;

  return {
    selectedVersions,
    setSelectedVersions,
    selectorEpoch,
    resetSelection,
    canDelete,
    canUseSingleVersion,
  };
}
